import { Controller } from 'stimulus';
import { prettyPrice } from '@/helpers/ecommerce/cartHelpers';
import debounce from '@/helpers/debounce';

const updateQuantity = (orderListItemId, quantity) => $.ajax({
  url: `/account/order-list-item/${orderListItemId}`,
  method: 'POST',
  data: {
    _method: 'PUT',
    quantity,
  },
});

class OrderList extends Controller {
  static updatePriceForItem(orderListItem) {
    const quantityInput = orderListItem.querySelector('[data-target*="order-list.quantityInput"]');
    const priceOutput = orderListItem.querySelector('[data-target="order-list.orderListItemPriceOutput"]');

    const quantity = parseInt(quantityInput.value, 10);
    const price = parseFloat(orderListItem.getAttribute('data-price'));

    if (Number.isNaN(quantity) || Number.isNaN(price) || !priceOutput) {
      return 0;
    }

    priceOutput.innerHTML = prettyPrice(price * quantity);

    return price * quantity;
  }

  static removeItem(item) {
    item.parentNode.removeChild(item);
  }

  connect() {
    // eslint-disable-next-line max-len
    this.updateOrderListItemPricesDebounced = debounce(this.updateOrderListItemPrices.bind(this), 20);
    this.changeQuantityDebounced = debounce(this.changeQuantity.bind(this), 20);
  }

  onQuantityChange({ target }) {
    this.changeQuantityDebounced(target);
  }

  changeQuantity(target) {
    const item = target.closest('[data-target="order-list.orderListItem"]');
    const quantity = target.value;
    const itemId = item.getAttribute('data-id');

    if (parseInt(quantity, 10) === 0) {
      OrderList.removeItem(item);
    }

    requestAnimationFrame(() => {
      updateQuantity(itemId, quantity)
        .then((res) => {
          this.updateOrderListItemPricesDebounced(item, res);
          this.updatePricesDebounced();
        })
        .catch(() => {
          this.updatePricesDebounced();
        });
    });
  }

  outputToCartPage(cartSpecifications) {
    if (this.hasSubTotalTarget) {
      this.subTotalTarget.innerHTML = cartSpecifications.subTotal;
    }

    if (this.hasTotalTaxTarget) {
      this.totalTaxTarget.innerHTML = cartSpecifications.totalTax;
    }

    if (this.hasTotalTarget) {
      this.totalTarget.innerHTML = cartSpecifications.total;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  updateOrderListItemPrices(item, res) {
    const priceOutput = item.querySelector('[data-target="order-list.orderListItemPriceOutput"]');
    const totalPriceOutput = item.querySelector('[data-target="order-list.orderListItemTotalPriceOutput"]');

    priceOutput.innerHTML = prettyPrice(res.price);
    totalPriceOutput.innerHTML = prettyPrice(res.total);
  }

  addToOrderList(e) {
    if (!this.hasAddToOrderListButtonTarget) {
      return;
    }

    const element = e.target.closest('[data-target="order-list.addToOrderListButton"]');
    const orderlistId = element.getAttribute('data-id');

    $.ajax({
      url: '/cart/bulk',
      method: 'POST',
      data: {
        orderListId: orderlistId,
      },
    })
      .then(() => {
        window.location.href = window.app.api.cart;
      });
  }

  editName() {
    if (this.nameInputFormTarget.style.display !== 'none') {
      return;
    }

    this.titleTarget.style.display = 'none';
    this.nameInputFormTarget.style.display = 'block';

    const input = this.nameInputFormTarget.querySelector('input[name="name"]');
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  }

  deleteOrderList(e) {
    // eslint-disable-next-line no-alert
    if (!window.confirm('Weet je zeker dat je deze lijst wilt verwijderen?')) {
      return;
    }

    const form = e.target.closest('form');
    form.submit();
  }

  deleteOrderListItem(e) {
    const { deleteRoute, orderListItemId } = e.currentTarget.dataset;

    if (!deleteRoute) {
      return;
    }

    $.ajax({
      url: deleteRoute,
      method: 'DELETE',
      data: {
        orderListId: orderListItemId,
      },
    })
      .then(() => {
        window.location.reload();
      });
  }
}

OrderList.targets = [
  'cartItem',
  'orderList',
  'orderListItem',
  'quantityInput',
  'subTotal',
  'totalTax',
  'totalSavings',
  'total',
  'addToOrderListButton',
  'title',
  'nameInputForm',
];

export default OrderList;
